export default __webpack_public_path__ + "static/media/INTA_icon.3a388585.svg";